import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=a6ef6a92&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6ef6a92')) {
      api.createRecord('a6ef6a92', component.options)
    } else {
      api.reload('a6ef6a92', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=a6ef6a92&", function () {
      api.rerender('a6ef6a92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4vB46NYzGL6sF/JS/cancellationPolicy.vue"
export default component.exports